module.exports = __webpack_public_path__ + "img/borg.fee9a4da.png";